import React from 'react';
import {createStore, applyMiddleware, compose} from 'redux';
import reducers from '../reducers/index';
import thunkMiddleware from 'redux-thunk';

import DevTools from './DevTools';

const enhancer = compose(
    // Middleware you want to use in development:
    applyMiddleware(thunkMiddleware),
    DevTools.instrument()
  )
  
  const store = createStore(reducers, enhancer);

  if (module.hot) {
      module.hot.accept(() => {
          const nextRootReducer = require('../reducers/index').default;
          store.replaceReducer(nextRootReducer)
      });
  }
// export function configureStore(initialState) {

//     return store;
// };

export default store;


// WEBPACK FOOTER //
// ./store/index.js